<div class="row">
  <div class="col-12">
    <span class="secondary-details mr-2">{{
      'mapping.customLineItemMapping.createEditInvoiceSpecification' | translate
    }}</span>
    <small class="text-danger text-right">{{
      'mapping.customLineItemMapping.allIndicatedFieldsMandatory' | translate
    }}</small>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12">
    <mat-radio-group
      aria-label="Select an option"
      name="invOpt1"
      (change)="specModeChangeEvent($event)"
      [(ngModel)]="specMode">
      <mat-radio-button class="me-2" value="Create_New">{{
        'global.create' | translate
      }}</mat-radio-button>
      <mat-radio-button value="Edit">{{ 'global.edit' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div class="row mt-2 mb-2" cdkDropListGroup>
  <div class="col-md-4">
    <div class="row">
      <div class="col-12 mb-2" *ngIf="isSpecEditMode()">
        <label>{{ 'mapping.customLineItemMapping.selectInvoice' | translate }}</label>
        <div>
          <mat-select
            class="form-control"
            [(ngModel)]="selectedSpec"
            (selectionChange)="specSelectEvent($event)"
            placeholder="Select specification">
            <mat-option *ngFor="let spec of mappingOptions" [value]="spec">
              {{ spec.specifications_id }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-12">
        <div [formGroup]="lineItemMappingForm">
          <div class="row" *ngIf="!isSpecEditMode()">
            <div class="col-4">
              <label class="required-field">{{
                'mapping.customLineItemMapping.specificationName' | translate
              }}</label>
            </div>
            <div class="col-8">
              <input
                class="form-control"
                maxlength="52"
                size="52"
                formControlName="specifications_id" />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-4">
              <label class="required-field">{{
                'mapping.customLineItemMapping.delimiter' | translate
              }}</label>
            </div>
            <div class="col-8 align-items-start">
              <input maxlength="1" size="1" formControlName="delimiter" />
            </div>
          </div>

          <div class="row mt-1">
            <div class="col-4">
              <label class="control-label">{{
                'mapping.customLineItemMapping.headers' | translate
              }}</label>
            </div>
            <div class="col-8 mt-1">
              <mat-checkbox formControlName="headers"></mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <h5 class="ml-2">{{ 'mapping.customLineItemMapping.availableColumns' | translate }}</h5>

    <div class="example-container">
      <div
        style="height: 100vh; overflow-y: auto"
        cdkDropList
        id="cdk1"
        [cdkDropListData]="unMappedFields"
        class="lineItem-list"
        (cdkDropListDropped)="drop($event)">
        <div class="lineItem-box" *ngFor="let item of unMappedFields" cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h5 class="ml-2">{{ 'mapping.customLineItemMapping.csvFileColumns' | translate }}</h5>
    <div class="example-container">
      <div
        style="height: 100vh; overflow-y: auto"
        cdkDropList
        id="cdk2"
        [cdkDropListData]="mappedFields"
        class="lineItem-list"
        (cdkDropListDropped)="drop($event)">
        <div
          class="lineItem-box"
          *ngFor="let item of mappedFields"
          [ngClass]="{ 'required-field': isFieldMandatory(item) }"
          cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <button type="submit" (click)="saveLineItemConfigMapping()" class="primary-btn pull-right">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
